import request from "@/utils/request";

export function apiGetUniq(params) {
  return request({
    url: "/user/uniq",
    method: "get",
    params,
  });
}

export function apiUserRegister(data) {
  return request({
    url: "/user/register",
    method: "post",
    data: data,
  });
}

export function apiGetMsgCode(params) {
  return request({
    url: "/user/getCode",
    method: "get",
    params,
  });
}

export function apiGetUserCaptcha(params) {
  return request({
    url: "/user/captcha",
    method: "get",
    params,
  });
}

export function apiUserLogin(data) {
  return request({
    url: "/user/login",
    method: "post",
    data,
  });
}

export function apiUserUpdate(data) {
  return request({
    url: "/user/update",
    method: "post",
    data,
  });
}

export function apiUserUpdatePassword(params) {
  return request({
    url: "/user/updatePassword",
    method: "get",
    params,
  });
}

export function apiUserCreaetOrder(data) {
  return request({
    url: "/order/create",
    method: "post",
    data,
  });
}

export function apiUserOrderList(params) {
  return request({
    url: "/order/list",
    method: "get",
    params,
  });
}

export function apiUserOrderBatchList(params) {
  return request({
    url: "/order/batchList",
    method: "get",
    params,
  });
}

export function apiUserOrderCancel(data) {
  return request({
    url: "/order/batchCancel",
    method: "post",
    data,
  });
}

export function apiUserResetPassword(data) {
  return request({
    url: "/user/resetPassword",
    method: "post",
    data,
  });
}

export function apiGoodsList(params) {
  return request({
    url: "/goods/list",
    method: "get",
    params,
  });
}

export function apiItemList(params) {
  return request({
    url: "/order/itemList",
    method: "get",
    params,
  });
}

export function apiFineList(params) {
  return request({
    url: "/fine/list",
    method: "get",
    params,
  });
}

export function apiCostList(params) {
  return request({
    url: "/order/costList",
    method: "get",
    params,
  });
}

export function apiInvoiceAdd(data) {
  return request({
    url: "/invoice/add",
    method: "post",
    data,
  });
}

export function apiInvoiceList(params) {
  return request({
    url: "/invoice/list",
    method: "get",
    params,
  });
}

export function apiInvoiceInfo(params) {
  return request({
    url: "/invoice/info",
    method: "get",
    params,
  });
}
